import { render, staticRenderFns } from "./BasicsTab.vue?vue&type=template&id=2f82d2cd&scoped=true"
import script from "./BasicsTab.vue?vue&type=script&lang=js"
export * from "./BasicsTab.vue?vue&type=script&lang=js"
import style0 from "./BasicsTab.vue?vue&type=style&index=0&id=2f82d2cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f82d2cd",
  null
  
)

export default component.exports